// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1k0j9","errorLogs":"styles_errorLogs__c-VNv"};